import React from 'react';
import ReactDOM from 'react-dom/client';

// ✅ IMPORT CAROUSEL CSS FIRST to avoid postcss error
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

// 👇 Import MUI theme tools
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme'; // make sure theme.js is in src/

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </GoogleOAuthProvider>
);

reportWebVitals();


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//  <React.StrictMode> </React.StrictMode>

